
<div class="follow-chat">
  <form class="ui form">
    <div class="field">
      <label>送信先まるなげID(カンマ区切り)</label>
      <input type="text" v-model="marunageIds" placeholder="例：555,556,557" />
    </div>
    <div class="field">
      <label>メッセージ</label>
      <textarea v-model="message" rows="30" />
    </div>
    <div class="field">
      <button type="button" class="ui positive button" @click="send()" :class="{'disabled': !ready, 'loading': loading}">送信する</button>
    </div>
  </form>
  <p v-if="count > 0" class="ui message positive">{{ count }}/{{ totalCount }}件送信済み</p>
</div>
